module.exports = __WEBPACK_EXTERNAL_MODULE_56__;


//////////////////
// WEBPACK FOOTER
// external "fenix-ui-DataEditor"
// module id = 56
// module chunks = 0